export default __webpack_public_path__ + "static/media/AAA.63d466ff.svg";